import { render, staticRenderFns } from "./MyPractice.vue?vue&type=template&id=9200749c&"
import script from "./MyPractice.vue?vue&type=script&lang=js&"
export * from "./MyPractice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports